import FileIcon from "lib/assets/svg/file";
import FilePenIcon from "lib/assets/svg/file-pen";
import HomeIcon from "lib/assets/svg/home";
import MagnifyingGlassIcon from "lib/assets/svg/magnifying-glass";
import PhoneIcon from "lib/assets/svg/phone";
import UploadIcon from "lib/assets/svg/upload";
import UserIcon from "lib/assets/svg/user";
import IdCardIcon from "lib/assets/svg/id-card";

export const menu = [
  {
    name: "Home",
    link: "/",
    icon: HomeIcon,
    beta: false,
    isProtected: false, // Public menu item
    isCommonRoute: true, // Common route for all users
  },
  {
    name: "Register",
    link: "/register",
    icon: FilePenIcon,
    beta: false,
    isProtected: false, // Public menu item
    onlyNonAuth: true, // Hide if user is logged in
  },
  {
    name: "Login",
    link: "/login",
    icon: FileIcon,
    beta: false,
    isProtected: false, // Public menu item
    onlyNonAuth: true, // Hide if user is logged in
  },
  {
    name: "My Profile",
    link: "/profileedit",
    icon: UserIcon,
    beta: false,
    isProtected: true, // Protected menu item
  },
  {
    name: "Dashboard",
    link: "/dashboard",
    icon: IdCardIcon,
    beta: false,
    isProtected: true, // Protected menu item
  },
  {
    name: "Admin Dashboard",
    link: "/admin/dashboard",
    icon: IdCardIcon,
    beta: false,
    isProtected: true,
    requiresAdmin: true,
  },
  {
    name: "Search Profile",
    link: "/search-profiles",
    icon: MagnifyingGlassIcon,
    beta: false,
    isProtected: true, // Protected menu item
  },
  {
    name: "Contact Us",
    link: "/contact-us",
    icon: PhoneIcon,
    isProtected: false, // Public menu item
    isCommonRoute: true, // Common route for all users
  },
  {
    name: "Quick Upload",
    link: "/quick-upload",
    icon: UploadIcon,
    isProtected: false, // Public menu item
    isCommonRoute: true, // Common route for all users
    onlyNonAuth: true, // Hide if user is logged in
  },
];
